import { DetailedServices } from '../container';

const DetailedServicesPage = () => {
  return <DetailedServices />;
};
export default DetailedServicesPage;
